import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureHeroContent } from '../utils/infrastructureContent';

export const useInfrastructureHeroContent = () =>
  useInfrastructureSectionContent(parseInfrastructureHeroContent);
